import vehicle from './vehicle'
import category from './category'
import insurance from './insurance'
import plugin from './plugin'
import remoocCategory from './remooc-category'
import remooc from './remooc'

export default {
  vehicle,
  category,
  insurance,
  plugin,
  remoocCategory,
  remooc
}
